import React, { useState, useEffect ,useRef} from 'react';

import './view.css';
import Navbar from '../Navbar';
import { Link } from 'react-router-dom';
export default function FileList() {
  const [files, setFiles] = useState([]);
let bools=localStorage.getItem('address')?true:false;
const boolsref=useRef(bools);
const [walletadd,setwalletadd]=useState('');

useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://blissregency.com/showfiles.php', {
          // const response = await fetch('http:localhost/phpreact/showfiles.php', {
          method: 'POST',
        
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ walletAddress: localStorage.getItem('address') }),
        });

        if (response.ok) {
          const data = await response.json();
          setFiles(data);
          console.log('Data received:', data);
        } else {
          alert('There is an Internal Server Error,Please Try Later...');
          console.error('Failed to fetch data:', response.status);
        }
      } catch (error) {
        alert('There is an Internal Server Error,Please Try Later...')
        console.error('Failed to fetch data:', error);
      }
    };

    fetchData();
  }, []);
 
  useEffect(() => {
    setwalletadd(localStorage.getItem('address'));
    console.log(boolsref.current);
    if (walletadd){
      boolsref.current = true;
   }
   }, [walletadd]);
   const viewFile = (cid) => {
    window.location.href = `http://localhost:8080/ipfs/${cid}`;
  };
  console.log(bools);
  return (
    <>
    <Navbar showMenu={false} alive={bools} walletConnected={bools} />

    <section id="writehere" style={{position:'relative'}} >
    <div className="container page-content d-flex justify-content-center align-items-center flex-column mt-5">
    <h2 className='mb-5'>VIEW YOUR DAO</h2>
        <div className='writeherecard'>
       
        {files.length > 0 ? (
        <>
           {files.map((file, index) => (
            <button
           type="button"
           className="btn btn-primary btn-lg w-100 walletBtn1" key={index} onClick={() => viewFile(file.cid)}>
            <span className="count" style={{marginRight:'10px'}}>{index + 1}.</span>
                   Will For {file.file_name}
              
             
            </button>
          ))}
          
          <div id='startWritingForm'>
                <Link
                to={{
                    pathname:'/writehere'
                }}>
                <button id='back'>Back To Main Menu</button>
                </Link>
           
            </div>
       </>
      
         )
         : (
          !bools ?(
            <>
            
            <div id='startWritingForm'>
            <h3 className='mb-4'>Please Connect Your Wallet To Start</h3>
                
           
            </div>
             
            </>
          ):(
            <>
            
            <div id='startWritingForm'>
            <h3 className='mb-4'>No DAO Found</h3>
                <Link
                to={{
                    pathname:'/writehere'
                }}>
                <button>Create DAO</button>
                </Link>
           
            </div>
             
            </>
          )
             
           )}
            </div>
       
       
        {/* <p>Data Address: {data?.address}</p> */}
      </div>
      
    </section>
    </>
  )
}
